import { render, staticRenderFns } from "./Step2Action.vue?vue&type=template&id=8fb5a3c0&scoped=true"
import script from "./Step2Action.vue?vue&type=script&lang=js"
export * from "./Step2Action.vue?vue&type=script&lang=js"
import style0 from "./Step2Action.vue?vue&type=style&index=0&id=8fb5a3c0&prod&scoped=true&lang=css"
import style1 from "./Step2Action.vue?vue&type=style&index=1&id=8fb5a3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb5a3c0",
  null
  
)

export default component.exports